import { createStructuredSelector } from 'reselect';
import {
  CAT_VEHICLE_TYPE_LIST, CAT_VEHICLE_TYPE_LIST_SUCCESS, CAT_VEHICLE_TYPE_LIST_ERROR,
  CAT_VEHICLE_TYPE_PAGE_SET,
  CAT_VEHICLE_TYPE_ADD, CAT_VEHICLE_TYPE_ADD_SUCCESS, CAT_VEHICLE_TYPE_ADD_ERROR,
  CAT_VEHICLE_TYPE_ADD_CHANGE,
  CAT_VEHICLE_TYPE_DETAIL, CAT_VEHICLE_TYPE_DETAIL_SUCCESS, CAT_VEHICLE_TYPE_DETAIL_ERROR,
  CAT_VEHICLE_TYPE_UPDATE, CAT_VEHICLE_TYPE_UPDATE_SUCCESS, CAT_VEHICLE_TYPE_UPDATE_ERROR,
} from '../../actions';

export const NAME = 'cat_vehicle_type';

export const CatalogVehicleTypeList = (page, num_page, orderBy, filters) => ({ type: CAT_VEHICLE_TYPE_LIST, payload: { page, num_page, orderBy, filters } });
export const CatalogVehicleTypeListSuccess = (data) => ({ type: CAT_VEHICLE_TYPE_LIST_SUCCESS, payload: data });
export const CatalogVehicleTypeListError = (error) => ({ type: CAT_VEHICLE_TYPE_LIST_ERROR, payload: error });
export const CatalogVehicleTypePageSet = (data) => ({ type: CAT_VEHICLE_TYPE_PAGE_SET, payload: data });
export const CatalogVehicleTypeAddChangeSet = (data) => ({ type: CAT_VEHICLE_TYPE_ADD_CHANGE, payload: data });
export const CatalogVehicleTypeAdd = (data) => ({ type: CAT_VEHICLE_TYPE_ADD, payload: data });
export const CatalogVehicleTypeAddSuccess = (message) => ({ type: CAT_VEHICLE_TYPE_ADD_SUCCESS, payload: message });
export const CatalogVehicleTypeAddError = (error) => ({ type: CAT_VEHICLE_TYPE_ADD_ERROR, payload: error });
export const CatalogVehicleTypeDetail = (data) => ({ type: CAT_VEHICLE_TYPE_DETAIL, payload: data });
export const CatalogVehicleTypeDetailSuccess = (data) => ({ type: CAT_VEHICLE_TYPE_DETAIL_SUCCESS, payload: data });
export const CatalogVehicleTypeDetailError = (error) => ({ type: CAT_VEHICLE_TYPE_DETAIL_ERROR, payload: error });
export const CatalogVehicleTypeUpdate = (data) => ({ type: CAT_VEHICLE_TYPE_UPDATE, payload: data });
export const CatalogVehicleTypeUpdateSuccess = (message) => ({ type: CAT_VEHICLE_TYPE_UPDATE_SUCCESS, payload: message.message });
export const CatalogVehicleTypeUpdateError = (error) => ({ type: CAT_VEHICLE_TYPE_UPDATE_ERROR, payload: error });

const cat_vehicle_type = (state) => state[NAME];
export const CatalogVehicleTypeSelector = createStructuredSelector({ cat_vehicle_type });
